import React, { isValidElement, PureComponent } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { Bubble } from '../Bubble';
import getStyle from './style';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
export class NoticeItem extends PureComponent {
    render() {
        const { onClick, customStyle, topNode, text, showNotice, noticeText, size, needScale, accessibilityPreName } = this.props;
        const { textColor, borderColor, noticeBgColor } = customStyle || {};
        let noticeLeft = noticeText ? 8 : 11;
        noticeLeft = size === 'small' ? noticeLeft - 5 : noticeLeft;
        // 提示位置
        const noticeExtraStyle = {
            top: 0,
            marginLeft: noticeLeft
        };
        const textExtraStyle = textColor
            ? {
                color: textColor
            }
            : {};
        const bubbleStyle = borderColor ? { borderColor } : {};
        noticeBgColor && (bubbleStyle.backgroundColor = noticeBgColor);
        const styles = getStyle(needScale);
        if (!isValidElement(topNode)) {
            return null;
        }
        return (<TouchableOpacity activeOpacity={0.6} style={styles.itemCon} {...qAccessibilityLabel(`${accessibilityPreName}qdNoticeItem#${text}`)} accessible={false} onPress={() => typeof onClick === 'function' ? onClick() : null}>
                <View style={size === 'small' ? styles.topConSmall : styles.topCon}>
                    {topNode}
                </View>
                <Text style={[styles.text, textExtraStyle]}>{text}</Text>
                {showNotice ? (<View style={[styles.noticeCon, noticeExtraStyle]}>
                        {typeof noticeText === 'string' ||
            typeof noticeText === 'number' ||
            !noticeText ? (<Bubble type="notice" text={noticeText ? `${noticeText}` : ''} customStyle={bubbleStyle} needScale={needScale}/>) : null}
                        {React.isValidElement(noticeText) ? noticeText : null}
                    </View>) : null}
            </TouchableOpacity>);
    }
}
